import { Component, OnInit } from '@angular/core';
import {LanguagesMap} from '../../const/common';
import {SubjectTest} from '../../models/subject-test';
import {ActivatedRoute} from '@angular/router';
import {SubjectTestService} from '../../services/subject-test.service';

@Component({
  selector: 'app-subject-test-permission',
  templateUrl: './subject-test-permission.component.html',
  styleUrls: ['./subject-test-permission.component.scss']
})
export class SubjectTestPermissionComponent implements OnInit {

  currentSubjectTest: SubjectTest = new SubjectTest();
  currentSubjectTestId: string;
  languagesMap = LanguagesMap;

  constructor(private route: ActivatedRoute,
              private subjectTestService: SubjectTestService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.currentSubjectTestId = params.get('id');
      this.subjectTestService.getSubjectTestById(this.currentSubjectTestId).then(res => {
        this.currentSubjectTest = res;
      });
    });
  }

}
